// Lib
import React from 'react';
import PropTypes from 'prop-types';

// Utils
import { getLinkUrl, getMediaType, getShowMedia } from '../../../../common/elements/utils/elementPropertyUtils';
import { getShouldApplyMediaOnlyDisplay } from '../../media/mediaElementDisplayUtils';
import { sanitiseUrl } from '../../../../common/utils/urlUtil';
import { openInNewTab } from '../../../reducers/navigationActions';

// Components
import LinkImage from './LinkImage';
import VideoMedia from '../../richMedia/components/video/VideoMedia';
import RichMedia from '../../richMedia/components/RichMedia';

// Constants
import { MEDIA_TYPES } from '../../../../common/links/richMediaConstants';

const LinkMediaElement = (props) => {
    const { element } = props;

    const showMedia = getShowMedia(element);
    if (!showMedia) return null;

    const mediaType = getMediaType(element);

    switch (mediaType) {
        case MEDIA_TYPES.VIDEO:
            return <VideoMedia {...props} />;
        // TODO Remove map when migrations have occurred
        case MEDIA_TYPES.MAP:
        case MEDIA_TYPES.RICH:
            return <RichMedia {...props} />;
        default:
            return <LinkImage {...props} />;
    }
};

const LinkMedia = (props) => {
    const { element, mediaElementRef, isPresentationModeEnabled } = props;

    const showMedia = getShowMedia(element);
    if (!showMedia) return null;

    // Media-only display hides the link title and URL, so the preview is the only way left to open the link.
    // It also hides the play overlay, so a click on the preview cannot embed the media.
    const canOpenLinkOnDoubleClick = !isPresentationModeEnabled && getShouldApplyMediaOnlyDisplay(props);

    const openLinkUrlOnPreviewDoubleClick = (event) => {
        event.preventDefault();

        const sanitisedHref = sanitiseUrl(getLinkUrl(element));
        if (!sanitisedHref) return;

        openInNewTab(sanitisedHref, 'noopener,noreferrer');
    };

    return (
        <div
            className="LinkMedia"
            ref={mediaElementRef}
            onDoubleClick={canOpenLinkOnDoubleClick ? openLinkUrlOnPreviewDoubleClick : null}
        >
            <LinkMediaElement {...props} />
        </div>
    );
};

LinkMediaElement.propTypes = LinkMedia.propTypes = {
    element: PropTypes.object.isRequired,
    mediaElementRef: PropTypes.object,
    isPresentationModeEnabled: PropTypes.bool,
};

export default LinkMedia;
